import React from 'react';
import styled from 'styled-components';
import { Check } from 'lucide-react';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: React.ReactNode;
}

const Root = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

const Control = styled.span`
  position: relative;
  display: inline-flex;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

const NativeInput = styled.input`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;

const Box = styled.span<{ $checked: boolean; $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 2px solid ${(p) => (p.$checked ? p.theme.primary : p.theme.border)};
  background: ${(p) => (p.$checked ? p.theme.primary : p.theme.surface)};
  color: #fff;
  transition: background 0.15s ease, border-color 0.15s ease;
  opacity: ${(p) => (p.$disabled ? 0.55 : 1)};
`;

const LabelText = styled.span`
  font-size: 0.9rem;
  color: ${(p) => p.theme.textSecondary};
`;

/** Custom checkbox matching the Kardume theme (no native browser control). */
const Checkbox: React.FC<CheckboxProps> = ({ label, checked, disabled, className, ...rest }) => (
  <Root className={className}>
    <Control>
      <NativeInput type="checkbox" checked={checked} disabled={disabled} {...rest} />
      <Box $checked={!!checked} $disabled={disabled} aria-hidden>
        {checked ? <Check size={14} strokeWidth={3} /> : null}
      </Box>
    </Control>
    {label != null && <LabelText>{label}</LabelText>}
  </Root>
);

export default Checkbox;
